import { DBFieldModel } from "./db-field-model";


export class CodeLinkageSettingsModel {
  project_management_fields: DBFieldModel[];
  technical_details_fields: DBFieldModel[];

  constructor(
    project_management_fields: DBFieldModel[],
    technical_details_fields: DBFieldModel[]
  ) {
    this.project_management_fields = project_management_fields;
    this.technical_details_fields = technical_details_fields;
  }
}